import { AMBIENTE } from '../../enums/Ambientes';
import { PRINT } from '../../enums/Documento';

export default class ModalConfigurationData {
  id = null;

  serie = '99';

  proximaNota = '';

  idTokenCSC = '';

  tokenCSC = '';

  documento = 55;

  ambiente = AMBIENTE.HOMOLOGACAO;

  ativo = true;

  isReducedPrint = false;

  codigoAtivacao = '';

  versao = 0;

  assinatura = null;

  intermediatorNFe = false;

  intermediatorNFCe = false;

  satIdentification = '';

  cfeSatMfeHomologIdentification = '';

  cfeSatMfeHomologIe = '';

  qrCodeVersion = '';

  transmissionMode = '';

  constructor({
    id = null,
    serie = '99',
    proximaNota = '',
    idTokenCSC = '',
    tokenCSC = '',
    documento = 55,
    ambiente = AMBIENTE.HOMOLOGACAO,
    ativo = true,
    printType = false,
    codigoAtivacao = '',
    versao = 0,
    assinatura = null,
    intermediatorNFe = false,
    intermediatorNFCe = false,
    satIdentification = '',
    cfeSatMfeHomologIdentification = '',
    cfeSatMfeHomologIe = '',
    qrCodeVersion = 200,
    transmissionMode = 1,
  }) {
    this.id = id;
    this.serie = serie;
    this.proximaNota = proximaNota;
    this.idTokenCSC = idTokenCSC;
    this.tokenCSC = tokenCSC;
    this.documento = documento;
    this.ambiente = ambiente;
    this.ativo = ativo;
    this.isReducedPrint = printType === PRINT.REDUCED;
    this.printType = printType;
    this.codigoAtivacao = codigoAtivacao;
    this.versao = versao;
    this.assinatura = assinatura;
    this.intermediatorNFe = intermediatorNFe;
    this.intermediatorNFCe = intermediatorNFCe;
    this.satIdentification = satIdentification;
    this.cfeSatMfeHomologIdentification = cfeSatMfeHomologIdentification;
    this.cfeSatMfeHomologIe = cfeSatMfeHomologIe;
    this.qrCodeVersion = qrCodeVersion;
    this.transmissionMode = transmissionMode;
  }
}
